export default __webpack_public_path__ + "static/media/login_bg_hg.6ad40eb4.jpg";